import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http'
import { environment } from 'src/environments/environment'
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ResponseData } from '../models/ResponseData';
import { anyChanged } from '@progress/kendo-angular-common';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  private baseUrl: string = ''

  constructor(
    private httpClient: HttpClient,
    private storage: StorageService,
  ) {
    this.baseUrl = environment.apiUrl
  }
  getHtml<T>(url: string): Observable<string> {
    const options = {};
    options["responseType"] = 'text';
    return this.httpClient.get(`${url}`, { responseType: 'text' });
  }

  getwithNoLoader<T>(url: string, id?: number | boolean, params?: any, headers?: any, publictokenKey: string = ''): Observable<T> {
    const options = {};
    if (!headers) {
      headers = [];
    }
    headers = new HttpHeaders().set('hideLoader', 'true');

    if (publictokenKey.length > 0) {
      const token = this.storage.getPublicStoredToken(publictokenKey)?.access_Token;
      if (token) {
        headers = headers.set('Authorization', `Bearer ${token}`);
      }
    }

    if (params) {
      options['params'] = params;
    }
    if (headers) {
      options['headers'] = headers;
    }


    if (id !== null && id !== undefined) {
      return this.httpClient.get<T>(`${url}/${id}`, options);
    } else {
      return this.httpClient.get<T>(`${url}`, options);
    }
  }

  get<T>(url: string, id?: number | boolean, params?: any, headers?: any): Observable<T> {
    const options = {};

    if (params) {
      options['params'] = params;
    }
    if (headers) {
      options['headers'] = headers;
    }

    if (id !== null && id !== undefined) {
      return this.httpClient.get<T>(`${url}/${id}`, options);
    } else {
      return this.httpClient.get<T>(`${url}`, options);
    }
  }
  postAutologin<T>(url: string, data: any): Observable<T> {

    return this.httpClient.post<T>(`${url}`, data);
  }
  postWihtoutLoader<T>(url: string, data: any): Observable<T> {
    const options = {};
    var headers = new HttpHeaders().set('hideLoader', 'true');
    options['headers'] = headers;
    return this.httpClient.post<T>(`${url}`, data, options);
  }
  post<T>(url: string, data: any): Observable<T> {
    console.warn(url);
    return this.httpClient.post<T>(`${url}`, data);
  }
  postNew(url: string, params: any = null, oldModel: any = null): Observable<ResponseData> {
    const options = {};
    var headers = new HttpHeaders().set('hideLoader', 'true');
    options['headers'] = headers;
    // this.loaderService.show();
    return this.httpClient.post(url, params, options).pipe(map((response: ResponseData) => {
      if (response != null) {
        // this.loaderService.hide();
        return response
      }
      else {
        throw new Error('Valid token not returned');
      }
    }, err => {
      // this.loaderService.hide();
    }));
  }
  put<T>(url: string, data: any): Observable<T> {
    return this.httpClient.put<T>(`${url}`, data);
  }
  putWithoutLoader<T>(url: string, data: any): Observable<T> {
    const options = {};
    var headers = new HttpHeaders().set('hideLoader', 'true');
    options['headers'] = headers;
    return this.httpClient.put<T>(`${url}`, data, options);
  }

  delete<T>(url: string, id: number): Observable<T> {
    return this.httpClient.delete<T>(`${url}/${id}`);
  }
  deleteWithoutLoader<T>(url: string, id: number): Observable<T> {

    const options = {};
    var headers = new HttpHeaders().set('hideLoader', 'true');
    options['headers'] = headers;
    return this.httpClient.delete<T>(`${url}/${id}`, options);
  }
  patch<T>(url: string, id: number, data?: any): Observable<T> {
    return this.httpClient.patch<T>(`${this.baseUrl}${url}/${id}`, data);
  }

  postWithHeader<T>(url: string, data: any, headers): Observable<T> {
    const options = {};
    if (headers) {
      options['headers'] = headers;
    }
    return this.httpClient.post<T>(`${url}`, data, options);
  }
}
